<script>
import Layout from '@layouts/guest.vue'
import { authMethods, authComputed } from '@state/helpers'
import organizationSignupForm from '@/src/guest/components/organization-signup-form.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Organization Sign Up` }],
  },
  components: { Layout, organizationSignupForm },
  data() {
    return {
      username: '',
      password: '',
      authError: '',
      signUpError: '',
      serverErrors: {},
    }
  },
  computed: { ...authComputed },
  methods: {
    ...authMethods,
    postSignupOrganization(params) {
      this.signUpError = ''
      this.serverErrors = {}
      return this.signupOrganization({
        nonprofitName: params.nonprofitName,
        profilePageName: params.profilePageName,
        missionStatement: params.missionStatement,
        adminName: params.adminName,
        adminEmail: params.adminEmail,
        mainWebsite: params.mainWebsite,
        volunteerWebsite: params.volunteerWebsite,
        isGoodStanding: params.isGoodStanding,
        nonprofitClassification: params.nonprofitClassification,
        isReligious: params.isReligious,
        isDiscriminating: params.isDiscriminating,
        isPolitical: params.isPolitical,
        isFederal: params.isFederal,
      }).then((response) => {
        // Check for error responses (422 validation errors or other errors)
        if (response.error || response.errors || response.success === false) {
          // Handle validation errors from backend
          this.signUpError =
            response.message || response.error || 'An error occurred'
          // Pass field-specific errors
          if (response.errors) {
            this.serverErrors = response.errors
          }
        } else {
          // Signup successful - response handling here if needed
        }
      })
    },
    clearSignUpErrors() {
      this.signUpError = ''
      this.serverErrors = {}
    },
  },
}
</script>

<template>
  <Layout style="height: fit-content" class="mt-20 mb-20">
    <organizationSignupForm
      :sign-up-error="signUpError"
      :server-errors="serverErrors"
      @post-signup-organization="postSignupOrganization"
      @clear-sign-up-errors="clearSignUpErrors"
    ></organizationSignupForm>
  </Layout>
</template>
